import { get } from 'helpers/api';

export function getCustomerData(url, params) {
  return get(url, { params });
}
